var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.408203,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#713FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.4082C25.52 10.4082 30 14.8882 30 20.4082C30 25.9282 25.52 30.4082 20 30.4082C14.48 30.4082 10 25.9282 10 20.4082C10 14.8882 14.48 10.4082 20 10.4082ZM14.023 23.8242C15.491 26.0142 17.695 27.4082 20.16 27.4082C22.624 27.4082 24.829 26.0152 26.296 23.8242C24.6317 22.2688 22.4379 21.405 20.16 21.4082C17.8817 21.4048 15.6875 22.2686 14.023 23.8242ZM20 19.4082C20.7956 19.4082 21.5587 19.0921 22.1213 18.5295C22.6839 17.9669 23 17.2039 23 16.4082C23 15.6126 22.6839 14.8495 22.1213 14.2869C21.5587 13.7243 20.7956 13.4082 20 13.4082C19.2044 13.4082 18.4413 13.7243 17.8787 14.2869C17.3161 14.8495 17 15.6126 17 16.4082C17 17.2039 17.3161 17.9669 17.8787 18.5295C18.4413 19.0921 19.2044 19.4082 20 19.4082Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f47cf22d.svg";
export { ForwardRef as ReactComponent };